var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"files"},[_c('zi-files-item',{attrs:{"files":_vm.files,"default-expand":_vm.defaultExpand},on:{"file-click":_vm.fileClickHandler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }